import { Card } from '@/components/sections/Card';
import { Product } from '@/services/api/contracts/catalog/types';
import { FC, PropsWithChildren } from 'react';
import { FaCheck } from 'react-icons/fa';
import { PriceBreakdown } from '../../../../pages/product/price/PriceHistoryModal';
import { ProductContent, ProductImage } from './ProductCard';

interface CreateBundleProductCardProps {
  product: Product;
  selected?: boolean;
}

export const CreateBundleProductCard: FC<PropsWithChildren<CreateBundleProductCardProps>> = ({
  product,
  selected = false,
  children
}) => {
  return (
    <Card className="flex flex-col items-stretch overflow-clip">
      <div className="flex border-b w-full relative">
        <ProductImage product={product} />
        {selected && (
          <FaCheck className="text-xl absolute right-0 top-0 w-[32px] h-[32px] rounded-full bg-primary-700 text-white p-1 mr-3 mt-3" />
        )}
      </div>
      <ProductContent product={product} />
      {selected && (
        <div className="bg-primary-700 text-white py-1 text-center">
          <p>Selected</p>
        </div>
      )}
      {product.price && (
        <div className="border-secondary-std group flex items-center justify-between gap-2 border-t bg-[#F3FCFE] px-4 py-3">
          <PriceBreakdown
            date={new Date(product.price.date)}
            percentages={[]}
            price={product.price.price}
            categoryId={product.category.id}
            manufacturerId={product.manufacturer.id}
            regionCode={product.region?.code}
          />
        </div>
      )}
      {children}
    </Card>
  );
};
